// Fixed column widths (only for special columns)
export const CHECKBOX_WIDTH = 70;
export const NO_COLUMN_WIDTH = 50;
export const DEFAULT_COLUMN_WIDTH = 150;

// Columns that cannot be cleared
export const CLEARABLE_BLOCKLIST = new Set(["name", "no", "owner", "update"]);

// Map column keys to founder update keys
export const colToUpdateKey: Record<
  string,
  | "email"
  | "company"
  | "roleTitle"
  | "industry"
  | "location"
  | "stage"
  | "status"
  | "tag"
  | "profileUrl"
> = {
  email: "email",
  company: "company",
  position: "roleTitle",
  industry: "industry",
  location: "location",
  stage: "stage",
  status: "status",
  tag: "tag",
  linkedinUrl: "profileUrl",
};
